// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import iView from "iview";
import i18n from "@/locale";
import config from "@/config";
import importDirective from "@/directive";
import { directive as clickOutside } from "v-click-outside-x";
import installPlugin from "@/plugin";
import "./index.less";
import "@/assets/icons/iconfont.css";
import TreeTable from "tree-table-vue";
import VOrgTree from "v-org-tree";
import "v-org-tree/dist/v-org-tree.css";
// 注册全局组件
import SvgIcon from '@/components/SvgIcon/index.vue'
// 导入 SVG 加载器
import '@/components/SvgIcon/svgLoader.js'
// 实际打包时应该不引入mock
/* eslint-disable */
// if (process.env.NODE_ENV !== 'production') require('@/mock')
// 全局引入相关包
import * as echarts from "echarts";
// 导入构建信息打印函数
import { printBuildInfo } from "@/config/git-info";

// 在应用初始化时打印构建信息
printBuildInfo();

// 开启echarts
Vue.prototype.$echarts = echarts;

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
});

// 配置全局 Message 组件
Vue.prototype.$Message.config({
  top: 50, // 距离顶部的百分比位置，50 表示居中
  duration: 3 // 默认显示时长 3 秒
});
Vue.use(TreeTable);
Vue.use(VOrgTree);
/**
 * @description 注册admin内置插件
 */
installPlugin(Vue);
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false;
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config;
/**
 * 注册指令
 */
importDirective(Vue);
Vue.directive("clickOutside", clickOutside);

// 添加调试功能到全局命令
window.addEventListener('DOMContentLoaded', () => {
  // 定义全局debug函数
  window.debug = {};

  // 使用代理来捕获debug-开头的属性访问
  const debugHandler = {
    get: function(target, prop) {
      if (typeof prop === 'string') {
        // 构建路由
        const routeData = router.resolve({
          path: "/debug",
          query: { code: prop }
        });

        // 打开新窗口
        window.open(routeData.href, "_blank");
      }
      return undefined;
    }
  };

  // 应用代理
  window.debug = new Proxy(window.debug, debugHandler);
  
  // 添加调试工具箱命令（使用 getter 属性）
  Object.defineProperty(window, 'debugTool', {
    get: function() {
      const routeData = router.resolve({
        path: "/debug-tools"
      });
      window.open(routeData.href, "_blank");
      return '调试工具箱已在新窗口打开';
    },
    configurable: true
  });
});

Vue.component('svg-icon', SvgIcon)

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  store,
  render: h => h(App)
});
